"use strict";

exports.__esModule = true;

require('./skip-to-content.css');

exports.default = {
  "skipToContent": "pf-c-skip-to-content"
};